module.exports = __webpack_public_path__ + "img/rewarded video.a8dbbbb4.png";